/**
 * 设置axios全局配置
 */

import axios from 'axios'
//引入cookie
import VueCookie from 'vue-cookies'
//引入elementUI
import router from '../router'
//引入elementUI
import {
  Message
} from 'element-ui'
//全局请求设置
axios.interceptors.request.use(config => {
  // 设置全局头
  config.headers = {
    'user-token': VueCookie.get('user_token'),
    'oauth-key': VueCookie.get('oauth_key'),
  }
  return config;
}, err => {
  return Promise.reject(err);
});
//登录拦截操作
axios.interceptors.response.use(
  (response) => {
    if (response.data.error == -1) {
      router.push({
        path: '/login'
      })
    
      return false
    } else {
      return response
    }
  }, (error) => {
    return Promise.reject(error);
  }

)

export default axios



// WEBPACK FOOTER //
// ./src/tools/http.js